import React from 'react'
import Pagination from 'react-bootstrap/Pagination';

function CustomPagination({ currentPage, totalPages, totalItems, limit, onPageChange }) {
    const getPageNumbers = () => {
        const pages = [];
        const maxVisiblePages = 5;
        const halfVisible = Math.floor(maxVisiblePages / 2);

        let startPage = Math.max(currentPage - halfVisible, 1);
        let endPage = Math.min(startPage + maxVisiblePages - 1, totalPages);

        if (endPage - startPage + 1 < maxVisiblePages) {
            startPage = Math.max(endPage - maxVisiblePages + 1, 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }
        return pages;
    };

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            onPageChange(page);
        }
    };

    const startEntry = ((currentPage - 1) * limit) + 1;
    const endEntry = Math.min(currentPage * limit, totalItems);

    return (
        <>
            <div className='custom-pagination d-md-flex justify-content-between align-items-center gap-3'>
                <p className='mb-2 mb-md-0'>Showing {startEntry} to {endEntry} of {totalItems} entries</p>
                <Pagination>
                    <li className="page-item">
                        <button
                            className="page-link"
                            onClick={() => handlePageChange(1)}
                            style={{
                                cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                background: 'none',
                                border: 'none',
                                padding: 0,
                                textDecoration: 'underline',
                                color: 'inherit'
                            }}
                            disabled={currentPage === 1}
                        >
                            <span aria-hidden="true">
                                <img src="/images/png/left-line.png" width={12} alt="" />
                            </span>
                        </button>


                    </li>
                    <li className="page-item">
                        <button
                            className="page-link"
                            onClick={() => handlePageChange(currentPage - 1)}
                            style={{
                                cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                background: 'none',
                                border: 'none',
                                padding: 0,
                                textDecoration: 'underline',
                                color: 'inherit'
                            }}
                            disabled={currentPage === 1}
                        >
                            <span aria-hidden="true">
                                <img src="/images/png/left.png" width={9} alt="" />
                            </span>
                        </button>

                    </li>

                    {currentPage > 3 && totalPages > 5 && (
                        <>
                            <Pagination.Item onClick={() => handlePageChange(1)}>{1}</Pagination.Item>
                            <Pagination.Ellipsis />
                        </>
                    )}

                    {getPageNumbers().map(pageNum => (
                        <Pagination.Item
                            key={pageNum}
                            active={pageNum === currentPage}
                            onClick={() => handlePageChange(pageNum)}
                        >
                            {pageNum}
                        </Pagination.Item>
                    ))}

                    {currentPage < totalPages - 2 && totalPages > 5 && (
                        <>
                            <Pagination.Ellipsis />
                            <Pagination.Item onClick={() => handlePageChange(totalPages)}>
                                {totalPages}
                            </Pagination.Item>
                        </>
                    )}

                    <li className="page-item">

                        <button
                            className="page-link"
                            onClick={() => handlePageChange(currentPage + 1)}
                            style={{
                                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                                background: 'none',
                                border: 'none',
                                padding: 0,
                                textDecoration: 'underline',
                                color: 'inherit'
                            }}
                            disabled={currentPage === totalPages}
                        >
                            <span aria-hidden="true">
                                <img src="/images/png/right.png" width={9} alt="" />
                            </span>
                        </button>


                    </li>
                    <li className="page-item">
                        <button
                            className="page-link"
                            onClick={() => handlePageChange(totalPages)}
                            style={{
                                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                                background: 'none',
                                border: 'none',
                                padding: 0,
                                textDecoration: 'underline',
                                color: 'inherit'
                            }}
                            disabled={currentPage === totalPages}
                        >
                            <span aria-hidden="true">
                                <img src="/images/png/right-line.png" width={12} alt="" />
                            </span>
                        </button>

                    </li>
                </Pagination>
            </div>
        </>
    )
}

export default CustomPagination
